/* PRESSIO ONE — refonte : apparitions, compteurs, barre des chambres */
(function(){
  if (window.__rfInit) return; window.__rfInit = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(){
    var sel = '.rf .rf-wrap > *:not(.g):not(.grid):not(.row):not(.chips):not(.steps):not(.tables), .rf .g > *, .rf .grid > *, .rf .row > *, .rf .chips > *, .rf .steps > *, .rf .card, .rf .bc, .rf .rc, .rf .st, .rf .v, .rf .box, .rf .gar, .rf .specs > *';
    var els = document.querySelectorAll(sel);
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function(e){ e.classList.add('rf-in'); }); }
    else {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){ if (en.isIntersecting) { en.target.classList.add('rf-in'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0 });
      var vh = window.innerHeight || 800;
      els.forEach(function(e, i){
        if (e.classList.contains('rf-in')) return;
        /* un bloc plus haut que l'écran (corps d'article, longue liste) s'affiche tout de suite */
        if (e.offsetHeight > vh * 0.7 || e.hasAttribute('data-rf-body') || e.querySelector('[data-rf-body]')) { e.classList.add('rf-in'); return; }
        e.classList.add('rf-reveal');
        var parent = e.parentElement; var idx = Array.prototype.indexOf.call(parent.children, e);
        e.style.setProperty('--rf-d', Math.min(idx, 8) * 70 + 'ms');
        io.observe(e);
      });
    }
    /* compteurs */
    document.querySelectorAll('[data-rf-count]').forEach(function(el){
      var raw = el.getAttribute('data-rf-count'); var m = raw.match(/^([^\d]*)(\d+)(.*)$/); if (!m) return;
      var pre = m[1], n = parseInt(m[2],10), suf = m[3]; if (reduce) return;
      el.textContent = pre + '0' + suf;
      var run = function(){ var t0 = null; var dur = 900;
        function step(ts){ if(!t0) t0 = ts; var p = Math.min(1,(ts-t0)/dur); var e = 1-Math.pow(1-p,3); el.textContent = pre + Math.round(n*e) + suf; if (p<1) requestAnimationFrame(step); }
        requestAnimationFrame(step); };
      if ('IntersectionObserver' in window) { var o = new IntersectionObserver(function(en){ if (en[0].isIntersecting) { run(); o.disconnect(); } }, {threshold:.5}); o.observe(el); } else run();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  setTimeout(function(){ document.querySelectorAll('.rf-reveal:not(.rf-in)').forEach(function(e){ var r=e.getBoundingClientRect(); if (r.top < (window.innerHeight||800)) e.classList.add('rf-in'); }); }, 2500);
  document.addEventListener('shopify:section:load', init);
})();
